import * as _ from 'underscore';

// Map between Latin characters and each possible diacritical representation
// Currently only supports Hawaiian diacriticals
// More support can be added as needed
var diacriticals = {
    '': ['\'', '\u02BB', '\u2018', '\u0304', '\u00AF', '\u02C9', '\u0331', '\u02CD'],
    'A': ['\u0100'],
    'a': ['\u0101'],
    'E': ['\u0112'],
    'e': ['\u0113'],
    'I': ['\u012A'],
    'i': ['\u012B'],
    'O': ['\u014C'],
    'o': ['\u014D'],
    'U': ['\u016A'],
    'u': ['\u016B']
};

var diacriticalKVPs = _.pairs(diacriticals),
    latinCharacters = {} as { [ch : string] : string };

for (var i = 0; i < diacriticalKVPs.length; i++) {
    var val = diacriticalKVPs[i][1];
    for (var j = 0; j < val.length; j++) {
        latinCharacters[val[j]] = diacriticalKVPs[i][0];
    }
}

/**
* Remove/replace diacriticals.
* 
* NOTE: Only setup for Hawaiian diacriticals currently.
*/
export function Latinize(str : string) {
    return str.replace(/[^\u0000-\u007E]|'/g, function (match) {
        var replacement = latinCharacters[match];
        if (replacement === undefined) replacement = match;
        return replacement;
    });
}

/**
 * Remove/replace diacrticals and convert to lower case
 * 
 * NOTE: Only setup for Hawaiian diacrticals currently.
 */
export function LatinLower(str : string) {
    return Latinize(str.toLowerCase());
}

export function CaseInsensitiveContains(str : string, query : string) {
    // special behavior: if query ends in a space, it must be a full-word match
    if (query.length > 0 && query[query.length - 1] === " ") {
        if (query[0] !== " ") query = " " + query;
        if (str.length > 0) {
            if (str[0] !== " ") str = " " + str;
            if (str[str.length - 1] !== " ") str += " ";
        }
    }

    return LatinLower(str).indexOf(LatinLower(query)) >= 0;
}

export function CaseInsensitiveStartsWith(str : string, query : string) {
    return LatinLower(str).indexOf(LatinLower(query)) === 0;
}


// WEBPACK FOOTER //
// ./lib/diacriticals.ts